import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class EmailNotificationFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled: boolean) {
        super(Features.EmailNotification, "MultiJurisdictionCms.Dto.Features.EmailNotificationFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.EmailNotificationFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}